
return rs;

}) ({}, jQuery);
